import React from 'react';

type AttentionProps = {
    className?: string;
    children?: React.ReactNode;
    direction: 'left' | 'right' | 'down' | 'up' | 'up-left' | 'up-right';
};

function Attention(props: AttentionProps) {
    const { className = '', children, direction } = props;

    let directionClass;
    switch (direction) {
        case 'left':
            directionClass = 'sf-attention--left';
            break;
        case 'right':
            directionClass = 'sf-attention--right';
            break;
        case 'down':
            directionClass = 'sf-attention--down';
            break;
        case 'up':
            directionClass = 'sf-attention--up';
            break;
        case 'up-left':
            directionClass = 'sf-attention--up-left';
            break;
        case 'up-right':
            directionClass = 'sf-attention--up-right';
            break;
    }

    return (
        <div className={`sf-attention ${directionClass} ${className}`}>
            {children}
        </div>
    );
}

export default Attention;
